import { Menu } from '../primitives';
import type { MenuItem } from '../primitives/Menu';
import type { PersonalTodosSort } from '../../lib/models/personalTodos';

const SORT_OPTIONS: ReadonlyArray<{ key: PersonalTodosSort; label: string }> = [
  { key: 'manual', label: 'Manual order' },
  { key: 'created_desc', label: 'Created (newest first)' },
  { key: 'created_asc', label: 'Created (oldest first)' },
  { key: 'priority_desc', label: 'Priority (high → low)' },
  { key: 'priority_asc', label: 'Priority (low → high)' }
];

export interface PersonalTodosSortMenuProps {
  sort: PersonalTodosSort;
  onChange: (next: PersonalTodosSort) => void;
  testIdPrefix?: string;
}

export function PersonalTodosSortMenu({
  sort,
  onChange,
  testIdPrefix = 'pt'
}: PersonalTodosSortMenuProps) {
  const currentLabel =
    SORT_OPTIONS.find((o) => o.key === sort)?.label ?? 'Manual order';

  const items: MenuItem[] = SORT_OPTIONS.map((opt) => {
    const selected = opt.key === sort;
    return {
      id: opt.key,
      'data-testid': `${testIdPrefix}-sort-item-${opt.key}`,
      label: (
        <span className="pn-listctl-menu-checkrow">
          <span className="pn-listctl-menu-check" aria-hidden="true">
            {selected ? '✓' : ''}
          </span>
          <span>{opt.label}</span>
        </span>
      ),
      onSelect: () => onChange(opt.key)
    };
  });

  return (
    <Menu
      trigger={(api) => (
        <button
          type="button"
          className="pn-btn pn-btn-sm"
          data-testid={`${testIdPrefix}-sort-trigger`}
          {...api}
        >
          {currentLabel} ▾
        </button>
      )}
      items={items}
      label="Sort todos"
      align="start"
      data-testid={`${testIdPrefix}-sort-menu`}
    />
  );
}
